class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      if (window.location.pathname === '/cart') {
        refreshCartYouMayAlsoLike();
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          // FREE GIFT
          if (typeof window.handleGiftProduct === 'function') {
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cartState) => {
                window.handleGiftProduct(cartState);
              })
              .catch((err) => {
                console.error('Error fetching cart for gift product logic during cart update:', err);
              });
          } 
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const cartyoumayalsolike = document.querySelector('.cart-you-may-also-like');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartyoumayalsolike) cartyoumayalsolike.classList.toggle('hidden', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        if (window.location.href.includes("cart")) {
          calculateTotalSaving();
          updateComfortPoints();
          refreshCartYouMayAlsoLike();
        }

        // FREE GIFT Function Calling
        setTimeout(() => {
          if (typeof window.handleGiftProduct === 'function') {
            window.handleGiftProduct(parsedState);
          }
        }, 100);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        // FREE GIFT Function Calling
        if (typeof window.handleGiftProduct === 'function') {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartState => {
              window.handleGiftProduct(cartState);
            })
            .catch(err => {
              console.error('Error fetching cart for gift product logic:', err);
            });
        } else {
          console.warn('handleGiftProduct function is not available on window.');
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }


  
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


// Updating cart page when you may also like product is added to cart
window.refreshCart = function () {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return;
  const sections = cartItems.getSectionsToRender();
  const sectionIds = sections.map((section) => section.section).join(',');
  const sectionsUrl = `${routes.cart_url}?sections=${sectionIds}`;

  let cartEmpty = false
  fetch(sectionsUrl)
    .then((res) => res.json())
    .then((parsedSections) => {
      sections.forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        if (elementToReplace && parsedSections[section.section]) {
          const html = new DOMParser().parseFromString(parsedSections[section.section], 'text/html');
          const cart_items = html.querySelector('cart-items')?.getAttribute('data-cart-items');
          if (cart_items == '0' || cart_items == 0) {
            cartEmpty = true
          }
          const inner = html.querySelector(section.selector);
          if (inner) elementToReplace.innerHTML = inner.innerHTML;
        }
      });

      // If cart is empty adding is-empty class to cart section
      if (cartEmpty) {
        emptyCart();
      }

      updateComfortPoints();
      refreshCartYouMayAlsoLike();
    })
    .catch((e) => console.error('Cart refresh failed', e));
};

// --- Begin Gift logic ---//

// Helper to refresh cart UI (bubble and drawer)
window.refreshCartUI = function () {
  if (!window.jQuery) return;

  // Sections to refresh: selector => optional callback after load
  const sections = [
    { selector: ".header #cart-icon-bubble" },
    { selector: ".header-dropdown_menu #cart-icon-bubble" },
    {
      selector: "#CartDrawer",
      callback: function () {
        const drawer = document.querySelector(".drawer");
        if (drawer) {
          drawer.classList.remove("is-empty");
          drawer.classList.add("animate", "active");
        }
      },
    },
  ];

  // Load each section if it exists
  sections.forEach(({ selector, callback }) => {
    document.querySelector('cart-drawer').classList.remove('is-empty');
    if ($(selector).length) {
      $(selector).load(location.href + " " + selector + " > *", callback);
    }
  });

  const cartDrawerItems = document.querySelector('cart-drawer')?.getAttribute('data-cart-count');
  if (cartDrawerItems && cartDrawerItems == '0' || cartDrawerItems == 0) {
    emptyCart()
  }
};

function emptyCart() {
  const cartWrapper = document.querySelector('cart-items');
  const cartFooter = document.querySelector('#main-cart-footer');
  if (cartFooter) cartFooter.classList.add('is-empty');
  if (cartWrapper) cartWrapper.classList.add('is-empty');
}

const freeGiftWrapper = document.querySelector('.free-gift-wrapper');
if (freeGiftWrapper) {
  const GIFT_VARIANT_ID = parseInt(freeGiftWrapper.getAttribute('data-free-gift-id'));
  const GIFT_THRESHOLD =  freeGiftWrapper.getAttribute('data-free-gift-threshold')*(Shopify.currency.rate);
  window.isGiftProductUpdating = false;

  window.handleGiftProduct = async function(cartState) {
    if (window.isGiftProductUpdating) return;
    window.isGiftProductUpdating = true;

    try {
      if (!cartState || !cartState.items) return releaseGiftLock();

      let totalPrice = 0;
      let giftLineIndexes = [];
      let giftCount = 0;

      cartState.items.forEach((item, idx) => {
        if (
          parseInt(item.variant_id) === GIFT_VARIANT_ID &&
          item.properties && item.properties._gift === 'true'
        ) {
          giftLineIndexes.push(idx + 1);
          giftCount += item.quantity;
        } else if (parseInt(item.variant_id) !== GIFT_VARIANT_ID || !item.properties || item.properties._gift !== 'true') {
          totalPrice += (item.final_line_price || (item.price * item.quantity)) / 100;
        }
      });

      if (totalPrice >= GIFT_THRESHOLD) {
        if (giftCount === 0) {
          await window.addGiftProductAsync(GIFT_VARIANT_ID);
        } else if (giftCount > 1) {
          await window.removeGiftProductsAsync(giftLineIndexes);
          await window.addGiftProductAsync(GIFT_VARIANT_ID);
        }
      } else if (giftLineIndexes.length > 0) {
        await window.removeGiftProductsAsync(giftLineIndexes);
      }
    } finally {
      releaseGiftLock();
    }
  };
}

function releaseGiftLock() {
  window.isGiftProductUpdating = false;
}

// Async/await wrappers for add/remove
window.addGiftProductAsync = async function(variantId, properties = {}) {
  const formData = {
    id: variantId,
    quantity: 1,
    properties: { _gift: 'true', ...properties }
  };
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  if (window.location.pathname === '/cart') {
    window.refreshCart();
  } else {
    window.refreshCartUI();
  }
  if (typeof window.onCartUpdate === 'function') window.onCartUpdate();
};

window.removeGiftProductsAsync = async function(lineIndexes) {
  for (const line of lineIndexes) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: 0 })
    });
  }
  if (window.location.pathname === '/cart') {
    window.refreshCart();
  } else {
    window.refreshCartUI();
  }
  if (typeof window.onCartUpdate === 'function') window.onCartUpdate();
};

// --- End gift logic  ---//


